import { render, staticRenderFns } from "./AppTranslationList.vue?vue&type=template&id=7f4ef3d2&scoped=true&"
import script from "./AppTranslationList.vue?vue&type=script&lang=js&"
export * from "./AppTranslationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4ef3d2",
  null
  
)

export default component.exports